import { StyleSheet } from 'aphrodite';
import { hexToRgbA } from 'utils/styleUtil';
import typography from 'defaults/typography';

const getSkin = (theme) => {
    const globalProfiles = theme.globalProfiles;
	const skin = globalProfiles.palette;
	const myTypography = typography(theme);

    return StyleSheet.create({
		body:{
			background: skin.white
		},
		title:{
			fontFamily: "Nunito",
			fontStyle: "normal",
			fontWeight: "600",
			fontSize: "16px",
			lineHeight: "22px",
			color: "#000000",
		},

		description:{
			fontFamily: "Open Sans",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "12px",
			lineHeight: "16px",
			color: "#000000",
			opacity: "0.8"

		}
	});
}

export default getSkin;